import CustomSwiper from '@/_application/core/components/ui/custom-swiper';
import {ImageOptimized} from '@/_application/core/components/ui/image';
import Link from '@/_application/core/components/ui/link';
import {Banner} from '__generated__/__types__';
import {SwiperSlide} from 'swiper/react';
import {getBannerUrlByPath} from '@/_application/helpers/cdn-image';

export interface HomeBannerSwiperProps {
    midHomePageBanners?: Banner[];
}

function HomeBannerSwiper({midHomePageBanners = []}: HomeBannerSwiperProps) {
    //items that have banner image
    const sliderBannerList = midHomePageBanners.filter(banner => banner?.image);

    if (!sliderBannerList.length) {
        return null;
    }

    return (
        <div className="min-h-41.5">
            <CustomSwiper
                className="rounded-[1.25rem]"
                hasPagination
                hasNavigation
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}>
                {sliderBannerList.map((banner, index) => (
                    <>
                        {banner?.image && (
                            <SwiperSlide key={banner?.banner_id}>
                                <Link href={banner?.url_banner ?? 'javascript:;'}>
                                    <div className="relative overflow-hidden">
                                        <ImageOptimized
                                            src={getBannerUrlByPath(banner?.image)}
                                            alt={banner?.name ?? 'banner'}
                                            width={1204}
                                            height={250}
                                            className="h-full w-full object-cover"
                                            loading={index === 0 ? undefined : 'lazy'}
                                            priority={index === 0}
                                        />
                                    </div>
                                </Link>
                            </SwiperSlide>
                        )}
                    </>
                ))}
            </CustomSwiper>
        </div>
    );
}

export default HomeBannerSwiper;
